import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook for fetching active products for the public frontend
 */
export const useProductos = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('productos')
          .select(`
            *,
            categorias (
              id,
              nomCategoria,
              activo
            )
          `)
          .eq('activo', true)
          .order('orden', { ascending: true });

        if (error) throw error;
        setProductos(data || []);
      } catch (err) {
        console.error('Error fetching productos:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProductos();
  }, []);

  return { productos, loading, error };
};
